export type JazzToolsSymbol = SchemaInit | ItemsSym | MembersSym;

export const SchemaInit = "$SchemaInit$";
export type SchemaInit = typeof SchemaInit;

export const ItemsSym = "$items$";
export type ItemsSym = typeof ItemsSym;

export const MembersSym = "$members$";
export type MembersSym = typeof MembersSym;

export const TypeSym = "$type$";
export type TypeSym = typeof TypeSym;
